export default __webpack_public_path__ + "imgs/84d1a25a63a79be703bc44a5c36b385f.jpg";